import { render } from "./Page10.vue?vue&type=template&id=4c2644b8"
import script from "./Page10.vue?vue&type=script&lang=js"
export * from "./Page10.vue?vue&type=script&lang=js"

import "./Page10.vue?vue&type=style&index=0&id=4c2644b8&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__